export { default } from './FontLink';
